export default {
    auth: {},
    user: {},
    cart: {},
    review: {},
    //notification: { customer_name: '' },
    loading: false,
    notification: {}
};
